module.exports = __webpack_public_path__ + "static/img/增值电信许可证.d45895f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/增值电信许可证.jpg
// module id = Oed0
// module chunks = 1